import React, { useState } from 'react';
import { Modal as ModalSuite } from 'rsuite';
import './styles.css';
import api from '../../services/api';
import { toastSuccess, toastInfo, toastError } from '../../toasts';
import { ContainerFooter, MainOptionsModal, BtnClose, BtnCancel, BtnSave } from './styles';
import ModalReasonCancel from '../ModalReasonCancel/indet';
import { useConfig } from '../../hooks/config';

function Modal({ children, open, onClose, title, refresh, pedido }) {
  const [modalCancel, setModalCancel] = useState(false);
  const [reason, setReason] = useState('')
  const { config } = useConfig();

  const weekDaysMap = {
    'Seg': 'Segunda-feira',
    'Ter': 'Terça-feira',
    'Qua': 'Quarta-feira',
    'Qui': 'Quinta-feira',
    'Sex': 'Sexta-feira',
    'Sab': 'Sábado',
    'Dom': 'Domingo'
  };

  const getWeekDayObjects = () => {
    const days = localStorage.getItem('DiaSemana')?.split(',') || [];
    return days.map(day => ({ value: day, label: weekDaysMap[day] }));
  };

  const editarHorario = async () => {
    const listaDias = getWeekDayObjects();
    const localData = {
      IdEmpresa: localStorage.getItem('IdEmpresa'),
      DiaSemana: listaDias,
      Inicio: localStorage.getItem('Inicio'),
      Fim: localStorage.getItem('Fim')
    };

    if (localStorage.getItem('DiaSemana')) {
      await api.post('Horario/criar', localData).then(() => {
        toastSuccess('Horário cadastrado');
        refresh();
        ['DiaSemana', 'Inicio', 'Fim', 'IdEmpresa'].forEach(key => localStorage.removeItem(key));
        onClose();
      });
    } else {
      if (
        localStorage.getItem('IdDia') &&
        localStorage.getItem('Inicio') &&
        localStorage.getItem('Funciona') &&
        localStorage.getItem('Fim')
      ) {
        await api.patch(`horario/alterar/${localStorage.getItem('IdDia')}`, {
          Inicio: localStorage.getItem('Inicio'),
          Fim: localStorage.getItem('Fim'),
          Funciona: localStorage.getItem('Funciona'),
        }).then(() => {
          toastInfo('Horário alterado');
          refresh();
          ['IdDia', 'Inicio', 'Fim', 'Funciona'].forEach(key => localStorage.removeItem(key));
          onClose();
        });
      } else {
        toastError('Preencha todos os campos obrigatórios');
      }
    }
  };

  const alterarStatus = async () => {
    if(config?.DisableOrdersActions){
      toastError('Ações de pedidos estão desabilitadas');
      return;
    }
    await api.post('pedido/alterar', {
      Status: localStorage.getItem('pedidoStatus'),
      IdEntregador: localStorage.getItem('pedidoEntregador'),
      Id: pedido.Id,
      MotivoCancelamento: reason
    });
    refresh();
    onClose();
    if(modalCancel) setModalCancel(false);
    toastInfo('Pedido alterado para: ' + localStorage.getItem('pedidoStatus'));
    localStorage.removeItem('pedidoStatus');
    localStorage.removeItem('pedidoEntregador');
  };

  const handleCancelOrder = () => {
    setModalCancel(true);
    setReason(null)
    localStorage.setItem('pedidoStatus', 'CANCELADO');
  }

  return (
    <>
      {open && (
        <ModalSuite
          backdrop="static"
          open={open}
          onClose={onClose}
          size="lg"
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            minHeight: '100%'
          }}
        >
          <ModalSuite.Header>
            <ModalSuite.Title>{title}</ModalSuite.Title>
          </ModalSuite.Header>
          <ModalSuite.Body>{children}</ModalSuite.Body>
          <ModalSuite.Footer>
            <ContainerFooter>
              <BtnClose onClick={onClose}>Fechar</BtnClose>
              <MainOptionsModal>
                <BtnCancel onClick={() => handleCancelOrder()}>Cancelar pedido</BtnCancel>
                <BtnSave onClick={pedido ? alterarStatus : editarHorario}>Salvar alterações</BtnSave>
              </MainOptionsModal>
            </ContainerFooter>
          </ModalSuite.Footer>
        </ModalSuite>
      )}
      {modalCancel &&
        <ModalReasonCancel
          open={modalCancel}
          onClose={()=> setModalCancel(false)}
          reason={reason}
          setReason={setReason}
          alterarStatus={alterarStatus}
        />}
    </>
  );
}

export default Modal;
